import Navbar from "./components/Navbar"
import Footer from "./components/Footer"
import Film from "./pages/Film"
import Foto from "./pages/Foto"
import Home from "./pages/Home"
import Kontakt from "./pages/Kontakt"
import Datenschutz from "./pages/Datenschutz"
import Impressum from "./pages/Impressum"
import ScrollToTopButton from "./components/ScrollToTopButton"
import ScrollToTop from "./components/utils/ScrollToTop"
import { Route, Routes } from "react-router-dom"

function App() {
  return (
    <>
      <Navbar />
        <ScrollToTop/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/film" element={<Film />} />
          <Route path="/foto" element={<Foto />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
      <Footer />
      <ScrollToTopButton />
    </>
  )
}

export default App